/**
 * glas-bundle-lp.js
 * GLAS Edit landing page interactive logic
 * Fetches products from storefront JSON API
 * ES5 syntax for maximum theme compatibility
 */
(function() {
  'use strict';

  // -------------------------
  // State
  // -------------------------
  var selectedCards = [];
  var MAX = 3;
  var CURRENCY = 'EUR';
  var BUNDLE_PRICE = 149;
  var swipeDetected = false;

  // i18n strings (set from Liquid template before this script loads)
  var i18n = window.GLAS_EDIT_I18N || {};
  var STR = {
    choosePairs: i18n.choosePairs || 'Choose 3 pairs',
    selectedPattern: i18n.selectedPattern || '{count} of 3 selected \u2014 choose {remaining} more',
    completeText: i18n.completeText || 'Your Edit is complete!',
    countPattern: i18n.countPattern || '{count} of 3 selected',
    chooseBtn: i18n.chooseBtn || 'Choose Your 3',
    chooseMorePattern: i18n.chooseMorePattern || 'Choose {remaining} more',
    viewEdit: i18n.viewEdit || 'View Your Edit',
    cartEmpty: i18n.cartEmpty || 'No pairs selected yet',
    removeText: i18n.removeText || 'Remove',
    strengthLabel: i18n.strengthLabel || 'Strength',
    processingText: i18n.processingText || 'PROCESSING...',
    loadingText: i18n.loadingText || 'Loading products...',
    errorText: i18n.errorText || 'Could not load products. Please refresh.',
    checkoutBtn: i18n.checkoutBtn || 'Proceed to Checkout',
    lensReaders: i18n.lensReaders || null,
    lensBluelight: i18n.lensBluelight || null,
    lensTinted: i18n.lensTinted || null,
    lensSun: i18n.lensSun || null
  };

  // Localized lens type labels (falls back to English if not set)
  var LENS_LABELS = {
    'Readers': STR.lensReaders || 'Readers',
    'Blue Light': STR.lensBluelight || 'Blue Light',
    'Tinted': STR.lensTinted || 'Tinted',
    'Sunglasses': STR.lensSun || 'Sunglasses'
  };

  // Discount code map: cart total -> EDIT code
  // EUR codes apply directly; SEK codes calibrated to frozen manual FX rate
  var DISCOUNT_MAP = {
    // EUR (80/100 per pair)
    240: 'EDIT-240',
    260: 'EDIT-260',
    280: 'EDIT-280',
    300: 'EDIT-300',
    // SEK (795/995 per pair) -> SEK-calibrated codes (frozen rate ~11.2568)
    2385: 'EDIT-SE-2385',
    2585: 'EDIT-SE-2585',
    2785: 'EDIT-SE-2785',
    2985: 'EDIT-SE-2985',
    // NOK (895/1095 per pair) -> EUR codes (auto rate, ~1 NOK tolerance)
    2685: 'EDIT-240',
    2885: 'EDIT-260',
    3085: 'EDIT-280',
    3285: 'EDIT-300',
    // DKK (549/649 per pair) -> EUR codes (auto rate)
    1647: 'EDIT-240',
    1847: 'EDIT-260',
    2047: 'EDIT-280',
    2247: 'EDIT-300',
    // GBP (69/89 per pair) -> EUR codes (auto rate)
    207: 'EDIT-240',
    227: 'EDIT-260',
    247: 'EDIT-280',
    267: 'EDIT-300'
  };

  var BUNDLE_PRICES = {
    'EUR': 149, 'SEK': 1490, 'NOK': 1690, 'DKK': 1099, 'GBP': 129
  };

  // Market-rounded price tiers (Shopify Markets rounds after conversion)
  var PRICE_TIERS = {
    'EUR': [80, 100],
    'SEK': [795, 995],
    'NOK': [895, 1095],
    'DKK': [549, 649],
    'GBP': [69, 89]
  };

  function snapToTier(rawPrice) {
    var tiers = PRICE_TIERS[CURRENCY] || PRICE_TIERS['EUR'];
    var mid = (tiers[0] + tiers[1]) / 2;
    return rawPrice <= mid ? tiers[0] : tiers[1];
  }

  function detectCurrency(products) {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      CURRENCY = window.Shopify.currency.active;
    } else if (products.length > 0) {
      var price = parseFloat(products[0].variants[0].price);
      if (price > 500) CURRENCY = 'SEK';
    }
    BUNDLE_PRICE = BUNDLE_PRICES[CURRENCY] || 149;
    var stickyPrice = document.getElementById('stickyPrice');
    if (stickyPrice) stickyPrice.textContent = formatPrice(BUNDLE_PRICE);
    var cartTotal = document.getElementById('cartTotal');
    if (cartTotal) cartTotal.textContent = formatPrice(BUNDLE_PRICE);
  }

  function formatPrice(amount) {
    return Math.round(amount) + ' ' + CURRENCY;
  }

  // Variant lookup: product_id -> { strength -> variant_id }
  window.GLAS_VARIANTS = {};

  // -------------------------
  // Variant lookup
  // -------------------------

  function normalizeStrength(s) {
    s = s.trim();
    if (s === '0 (plano)') return '0.0';
    return s;
  }

  function lookupVariantId(productId, strength) {
    var key = normalizeStrength(strength);
    if (window.GLAS_VARIANTS && window.GLAS_VARIANTS[productId]) {
      var variantId = window.GLAS_VARIANTS[productId][key];
      if (variantId) return variantId;
    }
    return null;
  }

  // -------------------------
  // Product loading from API
  // -------------------------

  function loadProducts() {
    var page1 = fetch('/collections/sales/products.json?limit=250&page=1').then(function(r) { return r.json(); });
    var page2 = fetch('/collections/sales/products.json?limit=250&page=2').then(function(r) { return r.json(); });

    Promise.all([page1, page2]).then(function(results) {
      var allProducts = [];
      for (var i = 0; i < results.length; i++) {
        allProducts = allProducts.concat(results[i].products || []);
      }

      detectCurrency(allProducts);
      renderProducts(allProducts);
      buildVariantMap(allProducts);
      initSwipe();

      var activePill = document.querySelector('.strength-pill.active');
      if (activePill) {
        selectStrength(activePill);
      }
      updateProgress();
    }).catch(function(err) {
      console.error('GLAS Edit: failed to load products', err);
      var loading = document.getElementById('productLoading');
      if (loading) loading.textContent = STR.errorText;
    });
  }

  function classifyLens(title) {
    if (title.indexOf('Blue Light') !== -1) return { lens: 'bluelight', label: 'Blue Light' };
    if (title.indexOf('Tinted') !== -1) return { lens: 'tinted', label: 'Tinted' };
    if (title.indexOf('Sunglasses') !== -1) return { lens: 'sun', label: 'Sunglasses' };
    return { lens: 'readers', label: 'Readers' };
  }

  function parseModelColor(title, typeLabel) {
    var clean = title.replace(typeLabel, '').trim();
    var parts = clean.split(' ');
    var model = parts[0] || '';
    var color = parts.slice(1).join(' ').trim();
    return { model: model, color: color };
  }

  function renderProducts(products) {
    var grid = document.getElementById('productGrid');
    if (!grid) return;

    var strengthEl = document.querySelector('.strength-pill.active');
    var strengthText = strengthEl ? strengthEl.textContent.trim() : '+2.0';

    var html = '';

    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      var info = classifyLens(p.title);
      var displayLabel = LENS_LABELS[info.label] || info.label;
      var names = parseModelColor(p.title, info.label);
      var price = snapToTier(Math.round(parseFloat(p.variants[0].price)));
      var imageCount = (p.images && p.images.length) || 0;

      // Build carousel images
      var imagesHtml = '';
      var dotsHtml = '';

      if (imageCount > 0) {
        for (var k = 0; k < p.images.length; k++) {
          var imgSrc = p.images[k].src;
          var thumbSrc = imgSrc + (imgSrc.indexOf('?') !== -1 ? '&' : '?') + 'width=400';
          var isActive = k === 0 ? ' active' : '';
          var lazyAttr = (i < 12 && k === 0) ? '' : ' loading="lazy"';
          imagesHtml += '<img src="' + thumbSrc + '" alt="' + p.title.replace(/"/g, '&quot;') + '" class="carousel-img' + isActive + '" width="400" height="500" decoding="async"' + lazyAttr + '>';
          dotsHtml += '<span class="carousel-dot' + isActive + '"></span>';
        }
      }

      var arrowsHtml = '';
      if (imageCount > 1) {
        arrowsHtml = '<button class="carousel-prev" onclick="carouselPrev(event, this)">&#8249;</button>' +
          '<button class="carousel-next" onclick="carouselNext(event, this)">&#8250;</button>' +
          '<div class="carousel-dots">' + dotsHtml + '</div>';
      }

      html += '<div class="product-card"' +
        ' data-lens="' + info.lens + '"' +
        ' data-name="' + names.model + '"' +
        ' data-color="' + names.color + '"' +
        ' data-type="' + displayLabel + '"' +
        ' data-product-id="' + p.id + '"' +
        ' data-handle="' + p.handle + '"' +
        ' data-price="' + price + '"' +
        ' data-display-price="' + price + '"' +
        ' onclick="toggleProduct(this)">' +
        '<div class="check-circle"><svg viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg></div>' +
        '<div class="product-image">' +
          '<span class="product-lens-badge">' + displayLabel + '</span>' +
          '<span class="strength-badge">' + strengthText + '</span>' +
          imagesHtml +
          arrowsHtml +
        '</div>' +
        '<div class="product-info">' +
          '<div class="product-name">' + names.model + '</div>' +
          (names.color ? '<div class="product-color">' + names.color + '</div>' : '') +
          '<div class="product-price">' + formatPrice(price) + '</div>' +
        '</div>' +
      '</div>';
    }

    grid.innerHTML = html;
  }

  function buildVariantMap(products) {
    window.GLAS_VARIANTS = {};
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      var map = {};
      for (var j = 0; j < p.variants.length; j++) {
        var v = p.variants[j];
        map[v.option1] = v.id;
      }
      window.GLAS_VARIANTS[p.id] = map;
    }
  }

  // -------------------------
  // Image carousel
  // -------------------------

  function carouselPrev(event, btn) {
    event.stopPropagation();
    var card = btn.closest('.product-card');
    if (card) navigateCarousel(card, -1);
  }

  function carouselNext(event, btn) {
    event.stopPropagation();
    var card = btn.closest('.product-card');
    if (card) navigateCarousel(card, 1);
  }

  function navigateCarousel(card, direction) {
    var images = card.querySelectorAll('.carousel-img');
    var dots = card.querySelectorAll('.carousel-dot');
    if (images.length <= 1) return;

    var currentIndex = 0;
    for (var i = 0; i < images.length; i++) {
      if (images[i].classList.contains('active')) {
        currentIndex = i;
        break;
      }
    }

    var newIndex = currentIndex + direction;
    if (newIndex < 0) newIndex = images.length - 1;
    if (newIndex >= images.length) newIndex = 0;

    for (var j = 0; j < images.length; j++) {
      images[j].classList.remove('active');
      if (dots[j]) dots[j].classList.remove('active');
    }
    images[newIndex].classList.add('active');
    if (dots[newIndex]) dots[newIndex].classList.add('active');
  }

  function initSwipe() {
    var grid = document.getElementById('productGrid');
    if (!grid) return;

    var startX = 0;
    var startY = 0;
    var startCard = null;

    grid.addEventListener('touchstart', function(e) {
      var card = e.target.closest('.product-card');
      if (!card) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      startCard = card;
    }, { passive: true });

    grid.addEventListener('touchend', function(e) {
      if (!startCard) return;
      var endX = e.changedTouches[0].clientX;
      var endY = e.changedTouches[0].clientY;
      var diffX = startX - endX;
      var diffY = startY - endY;
      // Only horizontal swipe (ignore vertical scroll)
      if (Math.abs(diffX) > 30 && Math.abs(diffX) > Math.abs(diffY)) {
        swipeDetected = true;
        if (diffX > 0) {
          navigateCarousel(startCard, 1);
        } else {
          navigateCarousel(startCard, -1);
        }
        setTimeout(function() { swipeDetected = false; }, 100);
      }
      startCard = null;
    });
  }

  // -------------------------
  // Product selection
  // -------------------------

  function toggleProduct(card) {
    if (swipeDetected) return;
    if (card.classList.contains('unavailable')) return;

    if (card.classList.contains('selected')) {
      card.classList.remove('selected');
      selectedCards = selectedCards.filter(function(c) { return c.card !== card; });
    } else if (selectedCards.length < MAX) {
      card.classList.add('selected');
      selectedCards.push({ card: card, strength: getCurrentStrength() });
    } else {
      card.style.animation = 'shake 0.3s';
      setTimeout(function() { card.style.animation = ''; }, 300);
      return;
    }

    updateProgress();

    if (selectedCards.length === MAX) {
      setTimeout(function() { openCart(); }, 400);
    }
  }

  function updateProgress() {
    var count = selectedCards.length;

    var badge = document.getElementById('cartBadge');
    if (badge) badge.textContent = count;

    for (var i = 1; i <= 3; i++) {
      var dot = document.getElementById('dot' + i);
      if (dot) {
        if (i <= count) {
          dot.classList.add('filled');
        } else {
          dot.classList.remove('filled');
        }
      }
    }

    var text = document.getElementById('progressText');
    if (text) {
      if (count === 0) {
        text.textContent = STR.choosePairs;
      } else if (count < 3) {
        text.textContent = STR.selectedPattern
          .replace('{count}', count)
          .replace('{remaining}', (3 - count));
      } else {
        text.textContent = STR.completeText;
      }
    }

    var stickyCount = document.getElementById('stickyCount');
    var stickyBtn = document.getElementById('stickyBtn');
    if (stickyCount) {
      stickyCount.textContent = STR.countPattern.replace('{count}', count);
    }
    if (stickyBtn) {
      if (count === MAX) {
        stickyBtn.textContent = STR.viewEdit;
        stickyBtn.classList.add('ready');
      } else if (count > 0) {
        stickyBtn.textContent = STR.chooseMorePattern.replace('{remaining}', (3 - count));
        stickyBtn.classList.remove('ready');
      } else {
        stickyBtn.textContent = STR.chooseBtn;
        stickyBtn.classList.remove('ready');
      }
    }

    updateCartDrawer();
  }

  function updateCartDrawer() {
    var container = document.getElementById('cartItems');
    if (!container) return;

    if (selectedCards.length === 0) {
      container.innerHTML = '<p style="text-align:center;color:var(--gray-500);padding:24px 0;font-size:14px;">' + STR.cartEmpty + '</p>';
      return;
    }

    var allStrengths = ['0 (plano)', '+1.0', '+1.5', '+2.0', '+2.5', '+3.0', '+3.5'];
    var html = '';
    var totalDisplay = 0;

    for (var i = 0; i < selectedCards.length; i++) {
      var item = selectedCards[i];
      var card = item.card;
      var name = card.getAttribute('data-name') || '';
      var color = card.getAttribute('data-color') || '';
      var type = card.getAttribute('data-type') || '';
      var img = card.querySelector('.carousel-img.active') || card.querySelector('.carousel-img') || card.querySelector('.product-image img');
      var imgSrc = img ? img.src : '';
      var displayPrice = parseInt(card.getAttribute('data-display-price') || card.getAttribute('data-price') || '0', 10);
      totalDisplay += displayPrice;

      // Build strength <select> with available variants for this product
      var productId = card.getAttribute('data-product-id');
      var selectHtml = '<select class="cart-item-strength" onchange="updateItemStrength(' + i + ', this.value)">';
      for (var s = 0; s < allStrengths.length; s++) {
        var str = allStrengths[s];
        if (lookupVariantId(productId, str)) {
          var sel = (str === item.strength) ? ' selected' : '';
          selectHtml += '<option value="' + str + '"' + sel + '>' + str + '</option>';
        }
      }
      selectHtml += '</select>';

      html += '<div class="cart-item">' +
        '<div class="cart-item-image"><img src="' + imgSrc + '" alt="' + name + '"></div>' +
        '<div class="cart-item-details">' +
          '<div class="cart-item-name">' + name + (color ? ' ' + color : '') + '</div>' +
          '<div class="cart-item-meta">' + type + ' · ' + STR.strengthLabel + ' ' + selectHtml + '</div>' +
          '<button class="cart-item-remove" onclick="removeFromCart(' + i + ')">' + STR.removeText + '</button>' +
        '</div>' +
      '</div>';
    }

    container.innerHTML = html;

    var discount = totalDisplay - BUNDLE_PRICE;
    var cartOriginal = document.getElementById('cartOriginal');
    var cartDiscount = document.getElementById('cartDiscount');
    if (cartOriginal) cartOriginal.textContent = formatPrice(totalDisplay);
    if (cartDiscount) cartDiscount.textContent = '-' + formatPrice(discount);
  }

  function removeFromCart(index) {
    var item = selectedCards[index];
    if (item) {
      item.card.classList.remove('selected');
      selectedCards.splice(index, 1);
      updateProgress();
    }
  }

  // -------------------------
  // Cart drawer
  // -------------------------

  function openCart() {
    if (selectedCards.length === 0) return;
    updateCartDrawer();
    var overlay = document.getElementById('cartOverlay');
    var drawer = document.getElementById('cartDrawer');
    if (overlay) overlay.classList.add('open');
    if (drawer) drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    var overlay = document.getElementById('cartOverlay');
    var drawer = document.getElementById('cartDrawer');
    if (overlay) overlay.classList.remove('open');
    if (drawer) drawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  function handleStickyCta() {
    if (selectedCards.length === MAX) {
      openCart();
    } else {
      var chooseSection = document.getElementById('choose');
      if (chooseSection) {
        chooseSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }

  // -------------------------
  // Strength selector
  // -------------------------

  function selectStrength(pill) {
    var pills = document.querySelectorAll('.strength-pill');
    for (var i = 0; i < pills.length; i++) {
      pills[i].classList.remove('active');
    }
    pill.classList.add('active');

    var strengthText = pill.textContent.trim();
    var strength = normalizeStrength(strengthText);

    // Update badges and availability only on non-selected cards
    var cards = document.querySelectorAll('.product-card');
    for (var j = 0; j < cards.length; j++) {
      if (cards[j].classList.contains('selected')) continue;

      var badge = cards[j].querySelector('.strength-badge');
      if (badge) badge.textContent = strengthText;

      var productId = cards[j].getAttribute('data-product-id');
      var variantId = lookupVariantId(productId, strength);
      if (!variantId) {
        cards[j].classList.add('unavailable');
      } else {
        cards[j].classList.remove('unavailable');
      }
    }

    updateCartDrawer();
  }

  function getCurrentStrength() {
    var pill = document.querySelector('.strength-pill.active');
    return pill ? pill.textContent.trim() : '+2.0';
  }

  function updateItemStrength(index, newStrength) {
    if (index < 0 || index >= selectedCards.length) return;
    var item = selectedCards[index];
    var productId = item.card.getAttribute('data-product-id');
    var variantId = lookupVariantId(productId, newStrength);
    if (!variantId) return;
    selectedCards[index].strength = newStrength;
    // Sync the strength badge on the product card
    var badge = item.card.querySelector('.strength-badge');
    if (badge) badge.textContent = newStrength;
    updateCartDrawer();
  }

  // -------------------------
  // Filter tabs
  // -------------------------

  function filterProducts(tab, lens) {
    var allTab = document.querySelector('.filter-tab[data-lens="all"]');
    if (!allTab) {
      allTab = document.querySelector('.filter-tab');
    }

    if (lens === 'all') {
      var tabs = document.querySelectorAll('.filter-tab');
      for (var i = 0; i < tabs.length; i++) {
        tabs[i].classList.remove('active');
      }
      allTab.classList.add('active');
    } else {
      allTab.classList.remove('active');
      tab.classList.toggle('active');
      var anyActive = document.querySelector('.filter-tab.active');
      if (!anyActive) {
        allTab.classList.add('active');
      }
    }

    var activeTabs = document.querySelectorAll('.filter-tab.active');
    var activeFilters = [];
    for (var k = 0; k < activeTabs.length; k++) {
      var f = activeTabs[k].getAttribute('data-lens');
      if (f) activeFilters.push(f);
    }
    var showAll = activeFilters.indexOf('all') !== -1 || activeFilters.length === 0;

    var cards = document.querySelectorAll('.product-card');
    for (var j = 0; j < cards.length; j++) {
      if (showAll || activeFilters.indexOf(cards[j].getAttribute('data-lens')) !== -1) {
        cards[j].style.display = '';
      } else {
        cards[j].style.display = 'none';
      }
    }
  }

  // -------------------------
  // FAQ toggle
  // -------------------------

  function toggleFaq(el) {
    el.parentElement.classList.toggle('open');
  }

  // -------------------------
  // Discount code selection
  // -------------------------

  function getDiscountCode() {
    var total = 0;
    for (var i = 0; i < selectedCards.length; i++) {
      var price = parseInt(selectedCards[i].card.getAttribute('data-price') || '0', 10);
      total += price;
    }
    return DISCOUNT_MAP[total] || null;
  }

  // -------------------------
  // Checkout flow
  // -------------------------

  function checkout() {
    if (selectedCards.length !== MAX) return;

    var btn = document.querySelector('.checkout-btn');
    if (btn) {
      btn.textContent = STR.processingText;
      btn.disabled = true;
    }

    var items = [];
    for (var i = 0; i < selectedCards.length; i++) {
      var item = selectedCards[i];
      var productId = item.card.getAttribute('data-product-id');
      var variantId = lookupVariantId(productId, item.strength);
      if (variantId) {
        items.push({ id: variantId, quantity: 1 });
      }
    }

    if (items.length !== MAX) {
      console.error('GLAS Edit: could not resolve all variant IDs');
      if (btn) {
        btn.textContent = STR.checkoutBtn;
        btn.disabled = false;
      }
      return;
    }

    var code = getDiscountCode();

    fetch('/cart/clear.js', { method: 'POST' })
      .then(function() {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function(res) {
        if (!res.ok) {
          throw new Error('Cart add failed: ' + res.status);
        }
        if (code) {
          window.location.href = '/discount/' + code + '?redirect=/checkout';
        } else {
          window.location.href = '/checkout';
        }
      })
      .catch(function(err) {
        console.error('GLAS Edit checkout error:', err);
        if (btn) {
          btn.textContent = STR.checkoutBtn;
          btn.disabled = false;
        }
        window.location.href = '/cart';
      });
  }

  // -------------------------
  // Sticky CTA visibility
  // -------------------------

  function initStickyObserver() {
    var hero = document.querySelector('.hero');
    if (!hero || !window.IntersectionObserver) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        var cta = document.getElementById('stickyCta');
        if (!cta) return;
        if (!entry.isIntersecting) {
          cta.classList.add('visible');
        } else {
          cta.classList.remove('visible');
        }
      });
    }, { threshold: 0 });

    observer.observe(hero);
  }

  // -------------------------
  // Init
  // -------------------------

  function init() {
    initStickyObserver();
    loadProducts();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // -------------------------
  // Expose for inline onclick handlers
  // -------------------------
  window.toggleProduct = toggleProduct;
  window.selectStrength = selectStrength;
  window.filterProducts = filterProducts;
  window.toggleFaq = toggleFaq;
  window.openCart = openCart;
  window.closeCart = closeCart;
  window.handleStickyCta = handleStickyCta;
  window.removeFromCart = removeFromCart;
  window.updateItemStrength = updateItemStrength;
  window.checkout = checkout;
  window.carouselPrev = carouselPrev;
  window.carouselNext = carouselNext;

})();
